import { render, staticRenderFns } from "./PostLocations.vue?vue&type=template&id=694a861e&scoped=true"
import script from "./PostLocations.vue?vue&type=script&lang=js"
export * from "./PostLocations.vue?vue&type=script&lang=js"
import style0 from "./PostLocations.vue?vue&type=style&index=0&id=694a861e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694a861e",
  null
  
)

export default component.exports